import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b0fab94&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0fab94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b0fab94')) {
      api.createRecord('5b0fab94', component.options)
    } else {
      api.reload('5b0fab94', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5b0fab94&scoped=true", function () {
      api.rerender('5b0fab94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/message/index.vue"
export default component.exports